
import Assessment from "@material-ui/icons/Assessment";
import Dashboard from "@material-ui/icons/Dashboard";
import ApplicationIcon from "../../../assets/img/application.png"
import InProcessIcon from "../../../assets/img/process.png"
import SnbmittedIcon from "../../../assets/img/submited.png"
import ApprovalIcon from "../../../assets/img/tick.png"
import DisbursalIcon from "../../../assets/img/disbursal.png"
import CompletedIcon from "../../../assets/img/completed-task.png"
import RejectedIcon from "../../../assets/img/reject.png"
import ReportIcon from "../../../assets/img/report.png"
import { userRole } from "assets/properties/properties";
import { designation } from "assets/properties/properties";

const SidebarLinks = [
  {
    name: "Dashboard",
    url: "/loanservice/dashboard",
    icon: Dashboard,
    code: "DASHBOARD",
  },
  {
    name: "Application",
    url: "",
    icon: ApplicationIcon,
    code: "APPLICATION",
    children: [
      {
        name: "In Process",
        url: "/loanservice/inProcess",
        icon: InProcessIcon,
        code: "IN_PROCESS",
      },
      {
        name: "Credit Appraisal",
        url: "/loanservice/inProcess/V2",
        icon: InProcessIcon,
        code: "IN_PROCESS_V2",
      },
      {
        name: "Submitted",
        url: "/loanservice/submitted",
        icon: SnbmittedIcon,
        code: "SUBMITTED",
      },
      {
        name: "Pre Sanction Approval",
        url: "/loanservice/preSanction",
        icon: ApprovalIcon,
        code: "PRE_SANCTION_APPROVAL",
      },
      {
        name: "Deviation Approval",
        url: "/loanservice/deviation",
        icon: ApprovalIcon,
        code: "DEVIATION_APPROVAL",
      },
      {
        name: "Collateral Discrepancy Approval",
        url: "/loanservice/collateralApproval",
        icon: ApprovalIcon,
        code: "COLLATERAL_DISCREPANCY_APPROVAL",
      },
      {
        name: "Collateral Valuation Approval",
        url: "/loanservice/collateralEvaluation",
        icon: ApprovalIcon,
        code: "COLLATERAL_VALUATION",
      },
      {
        name: "Discrepancy Approval",
        url: "/loanservice/discrepancyApproval",
        icon: ApprovalIcon,
        code: "DISCREPANCY_APPROVAL",
      },
      {
        name: "For Approval",
        url: "/loanservice/approval",
        icon: ApprovalIcon,
        code: "FOR_APPROVAL",
      },
      {
        name: "Disbursal",
        url: "/loanservice/disbursal",
        icon: DisbursalIcon,
        code: "DISBURSAL",
      },
      {
        name: "Disburse To LMS",
        url: "/loanservice/disbursLms",
        icon: DisbursalIcon,
        code: "DISBURSE_TO_LMS",
      },
      {
        name: "Completed",
        url: "/loanservice/completed",
        icon: CompletedIcon,
        code: "COMPLETED",
      },
      {
        name: "Rejected",
        url: "/loanservice/rejected",
        icon: RejectedIcon,
        code: "REJECTED",
      },
      {
        name: "Personal Loan",
        url: "/loanservice/PersonalLoan",
        icon: RejectedIcon,
        code: "PERSONAL_LOAN",
      },
    ],
  },
  {
    name: "Lead Reports",
    url: "/loanservice/reports",
    icon: Assessment,
    code: "LEAD_REPORTS",
  },
  {
    name: "Reports",
    url: "/loanservice/generateReports",
    icon: ReportIcon,
    code: "REPORTS",
  },
  {
    name: "Reject Application",
    url: "/loanservice/rejectApplication",
    icon: ReportIcon,
    code: "REJECT_APPLICATION",
  },
  {
    name: "Gold Loan Calculator",
    url: "/loanservice/goldLoanCalculator",
    icon: ReportIcon,
    code: "REJECT_APPLICATION",
  },
];

export default SidebarLinks;